import { Link, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { CorporateScenarioPageContent } from '../components/scenarios/CorporateScenarioPageContent';

export default function ScenarioDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <div className="space-y-4">
        <Link to="/scenarios">
          <Button variant="ghost" className="mb-4">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Scenarios
          </Button>
        </Link>
        <p className="text-muted-foreground">Missing scenario ID.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <Link to="/scenarios">
        <Button variant="ghost" className="mb-4">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Scenarios
        </Button>
      </Link>
      <CorporateScenarioPageContent scenarioId={id} />
    </div>
  );
}
